import React, {useEffect, useRef, useState} from "react";

export const VoxSenatus = (props) => {
    // Timer duration constants
    const MAIN_TIMER_DURATION = 300; // 5 min in seconds
    const DEBATE_TIMER_DURATION = 210; // 3 min 30 sec in seconds
    const START_TIMER_DURATION = 420; // 7 min in seconds (for startTimer references)

    const TEAM_OPTIONS = ["GRECE", "BABYLONE", "EGYPTE", "CELTES"];
    const TOPICS = [
        "Pour ou contre la taxe Zucmanus : une taxe sur les riches patriciens pour financer l'Empire.",
        "Pour ou contre renommer la salade au poulet et croutons en 'Caesar' ?",
        "Pour ou contre limiter la vitesse des chars à 8 km/h sur la via Appia ?",
        "Pour ou contre constuire un mur au nord de l'Angleterre pour se protéger des Pictes ?",
    ];
    const [leftTeam1, setLeftTeam1] = useState(null);
    const [rightTeam1, setRightTeam1] = useState(null);
    const [subject1, setSubject1] = useState(null);
    const [leftTeam2, setLeftTeam2] = useState(null);
    const [rightTeam2, setRightTeam2] = useState(null);
    const [subject2, setSubject2] = useState(null);
    const [timerStart, setTimerStart] = useState(0);
    const [remaining, setRemaining] = useState(MAIN_TIMER_DURATION); // 5 min in seconds
    const [timer1, setTimer1] = useState(null); // in seconds
    const [timer2, setTimer2] = useState(null); // in seconds
    const [timer1Running, setTimer1Running] = useState(false);
    const [timer2Running, setTimer2Running] = useState(false);
    const [activeTimer, setActiveTimer] = useState(null); // 1 or 2

    // Use state from props if present
    useEffect(() => {
        if (props.state?.voxSenatusState) {
            if (props.state.voxSenatusState.leftTeam1 !== undefined) setLeftTeam1(props.state.voxSenatusState.leftTeam1);
            if (props.state.voxSenatusState.rightTeam1 !== undefined) setRightTeam1(props.state.voxSenatusState.rightTeam1);
            if (props.state.voxSenatusState.leftTeam2 !== undefined) setLeftTeam2(props.state.voxSenatusState.leftTeam2);
            if (props.state.voxSenatusState.rightTeam2 !== undefined) setRightTeam2(props.state.voxSenatusState.rightTeam2);
            if (props.state.voxSenatusState.subject1 !== undefined) setSubject1(props.state.voxSenatusState.subject1);
            if (props.state.voxSenatusState.subject2 !== undefined) setSubject2(props.state.voxSenatusState.subject2);
            if (props.state.voxSenatusState.timerStart) {
                setTimerStart(props.state.voxSenatusState.timerStart);
                const elapsed = Math.floor((Date.now() - props.state.voxSenatusState.timerStart) / 1000);
                setRemaining(Math.max(MAIN_TIMER_DURATION - elapsed, 0));
            }
            if (props.state.voxSenatusState.timer1 !== undefined && props.state.voxSenatusState.timer1 !== null) setTimer1(props.state.voxSenatusState.timer1);
            if (props.state.voxSenatusState.timer2 !== undefined && props.state.voxSenatusState.timer2 !== null) setTimer2(props.state.voxSenatusState.timer2);
            if (props.state.voxSenatusState.timer1Running !== undefined) setTimer1Running(props.state.voxSenatusState.timer1Running);
            if (props.state.voxSenatusState.timer2Running !== undefined) setTimer2Running(props.state.voxSenatusState.timer2Running);
        }
    }, [props.state?.voxSenatusState]);

    // Timer countdown effect
    useEffect(() => {
        if (!timerStart) return;
        if (remaining <= 0) return;
        const interval = setInterval(() => {
            const elapsed = Math.floor((Date.now() - timerStart) / 1000);
            setRemaining(Math.max(MAIN_TIMER_DURATION - elapsed, 0));
        }, 1000);
        return () => clearInterval(interval);
    }, [timerStart, remaining]);

    // Timer effects
    useEffect(() => {
        let interval;
        if (timer1Running) {
            interval = setInterval(() => {
                setTimer1(prev => {
                    let next = prev === null ? DEBATE_TIMER_DURATION : prev > 0 ? prev - 1 : 0;
                    if (next === 0) setTimer1Running(false);
                    // Save to main state
                    if (props.newState) {
                        props.newState({
                            ...props.state,
                            voxSenatusState: {
                                ...props.state.voxSenatusState,
                                timer1: next
                            }
                        });
                    }
                    return next;
                });
            }, 1000);
        }
        return () => clearInterval(interval);
    }, [timer1Running]);

    useEffect(() => {
        let interval;
        if (timer2Running) {
            interval = setInterval(() => {
                setTimer2(prev => {
                    let next = prev === null ? DEBATE_TIMER_DURATION : prev > 0 ? prev - 1 : 0;
                    if (next === 0) setTimer2Running(false);
                    // Save to main state
                    if (props.newState) {
                        props.newState({
                            ...props.state,
                            voxSenatusState: {
                                ...props.state.voxSenatusState,
                                timer2: next
                            }
                        });
                    }
                    return next;
                });
            }, 1000);
        }
        return () => clearInterval(interval);
    }, [timer2Running]);

    const handleSelect = (setter) => (e) => setter(e.target.value);
    const handleReset = () => {
        setLeftTeam1(null);
        setRightTeam1(null);
        setLeftTeam2(null);
        setRightTeam2(null);
        setSubject1(null);
        setSubject2(null);
        setTimerStart(0);
        setRemaining(MAIN_TIMER_DURATION);
        setTimer1(null);
        setTimer2(null);
        setTimer1Running(false);
        setTimer2Running(false);
        setActiveTimer(null);
        if (props.newState) {
            props.newState({
                ...props.state,
                voxSenatusState: {
                    leftTeam1: null,
                    rightTeam1: null,
                    leftTeam2: null,
                    rightTeam2: null,
                    subject1: null,
                    subject2: null,
                    timerStart: 0,
                    timer1: 0,
                    timer2: 0,
                    currentDebate: 0
                }
            });
        }
    };
    const handleSelectTeam = (setter, teamKey) => (e) => {
        const value = e.target.value;
        setter(value);
        if (props.newState) {
            props.newState({
                ...props.state,
                voxSenatusState: {
                    ...props.state.voxSenatusState,
                    [teamKey]: value
                }
            });
        }
    };
    // Update handleSelectTopic to support both debates
    const handleSelectTopic = (debate, topic) => {
        if (debate === 1) {
            setSubject1(topic);
            if (props.newState) {
                props.newState({
                    ...props.state,
                    voxSenatusState: {
                        ...props.state.voxSenatusState,
                        subject1: topic
                    }
                });
            }
        } else {
            setSubject2(topic);
            if (props.newState) {
                props.newState({
                    ...props.state,
                    voxSenatusState: {
                        ...props.state.voxSenatusState,
                        subject2: topic
                    }
                });
            }
        }
    };
    const handleStartTimer = () => {
        const now = Date.now();
        setTimerStart(now);
        setRemaining(START_TIMER_DURATION);
        if (props.newState) {
            props.newState({
                ...props.state,
                voxSenatusState: {
                    ...props.state.voxSenatusState,
                    timerStart: now
                }
            });
        }
    };

    // When starting or stopping timers, persist running state
    const startTimer1 = () => {
        setTimer1Running(true);
        setTimer2Running(false);
        setActiveTimer(1);
        setTimer1(timer1 !== null ? timer1 : DEBATE_TIMER_DURATION);
        setTimer2(timer2 !== null ? timer2 : DEBATE_TIMER_DURATION);
        if (props.newState) {
            props.newState({
                ...props.state,
                voxSenatusState: {
                    ...props.state.voxSenatusState,
                    timer1: timer1 !== null ? timer1 : DEBATE_TIMER_DURATION,
                    timer2: timer2 !== null ? timer2 : DEBATE_TIMER_DURATION,
                    timer1Running: true,
                    timer2Running: false
                }
            });
        }
    };
    const startTimer2 = () => {
        setTimer2Running(true);
        setTimer1Running(false);
        setActiveTimer(2);
        setTimer1(timer1 !== null ? timer1 : DEBATE_TIMER_DURATION);
        setTimer2(timer2 !== null ? timer2 : DEBATE_TIMER_DURATION);
        if (props.newState) {
            props.newState({
                ...props.state,
                voxSenatusState: {
                    ...props.state.voxSenatusState,
                    timer1: timer1 !== null ? timer1 : DEBATE_TIMER_DURATION,
                    timer2: timer2 !== null ? timer2 : DEBATE_TIMER_DURATION,
                    timer1Running: false,
                    timer2Running: true
                }
            });
        }
    };
    const stopBothTimers = () => {
        setTimer1Running(false);
        setTimer2Running(false);
        setActiveTimer(null);
        if (props.newState) {
            props.newState({
                ...props.state,
                voxSenatusState: {
                    ...props.state.voxSenatusState,
                    timer1Running: false,
                    timer2Running: false
                }
            });
        }
    };

    // Helper to get available teams for a select, excluding all already chosen teams except the current value
    const getAvailableTeams = (currentValue) => {
        const selected = [leftTeam1, rightTeam1, leftTeam2, rightTeam2].filter(t => t && t !== currentValue);
        return TEAM_OPTIONS.filter(team => !selected.includes(team));
    };
    // Helper to get available topics for a select, excluding the topic already chosen in the other block
    const getAvailableTopics = (currentValue, otherValue) => {
        return TOPICS.filter(topic => topic === currentValue || topic !== otherValue);
    };

    return (
        <div style={{minHeight: "60vh", width: "100%", marginBottom: "10vh"}} >
            <h1>Vox Senatus</h1>
            {/* First debate: Left Team 1 / Right Team 1 */}
            <div style={{display: "flex", width: "100%", marginBottom: "2em"}}>
                <div style={{flex: 1, padding: "1em", borderRight: "1px solid #ccc"}}>
                    <h2>Left Team 1</h2>
                    {leftTeam1 ? (
                        <div>{leftTeam1}</div>
                    ) : (
                        <select onChange={handleSelectTeam(setLeftTeam1, 'leftTeam1')} defaultValue="">
                            <option value="" disabled>Select Team</option>
                            {getAvailableTeams(leftTeam1).map(team => (
                                <option key={team} value={team}>{team}</option>
                            ))}
                        </select>
                    )}
                </div>
                <div style={{flex: 1, padding: "1em"}}>
                    <h2>Right Team 1</h2>
                    {rightTeam1 ? (
                        <div>{rightTeam1}</div>
                    ) : (
                        <select onChange={handleSelectTeam(setRightTeam1, 'rightTeam1')} defaultValue="">
                            <option value="" disabled>Select Team</option>
                            {getAvailableTeams(rightTeam1).map(team => (
                                <option key={team} value={team}>{team}</option>
                            ))}
                        </select>
                    )}
                </div>
            </div>
            {/* Topic selector for debate 1 */}
            <div style={{marginBottom: "2em"}}>
                <h3>Topic for Debate 1</h3>
                {subject1 ? (
                    <div>{subject1}</div>
                ) : (
                    <select onChange={e => handleSelectTopic(1, e.target.value)} value={subject1 || ""}>
                        <option value="" disabled>Select Topic</option>
                        {getAvailableTopics(subject1, subject2).map(topic => (
                            <option key={topic} value={topic}>{topic}</option>
                        ))}
                    </select>
                )}
            </div>
            {/* Second debate: Left Team 2 / Right Team 2 */}
            <div style={{display: "flex", width: "100%", marginBottom: "2em"}}>
                <div style={{flex: 1, padding: "1em", borderRight: "1px solid #ccc"}}>
                    <h2>Left Team 2</h2>
                    {leftTeam2 ? (
                        <div>{leftTeam2}</div>
                    ) : (
                        <select onChange={handleSelectTeam(setLeftTeam2, 'leftTeam2')} defaultValue="">
                            <option value="" disabled>Select Team</option>
                            {getAvailableTeams(leftTeam2).map(team => (
                                <option key={team} value={team}>{team}</option>
                            ))}
                        </select>
                    )}
                </div>
                <div style={{flex: 1, padding: "1em"}}>
                    <h2>Right Team 2</h2>
                    {rightTeam2 ? (
                        <div>{rightTeam2}</div>
                    ) : (
                        <select onChange={handleSelectTeam(setRightTeam2, 'rightTeam2')} defaultValue="">
                            <option value="" disabled>Select Team</option>
                            {getAvailableTeams(rightTeam2).map(team => (
                                <option key={team} value={team}>{team}</option>
                            ))}
                        </select>
                    )}
                </div>
            </div>
            {/* Topic selector for debate 2 */}
            <div style={{marginBottom: "2em"}}>
                <h3>Topic for Debate 2</h3>
                {subject2 ? (
                    <div>{subject2}</div>
                ) : (
                    <select onChange={e => handleSelectTopic(2, e.target.value)} value={subject2 || ""}>
                        <option value="" disabled>Select Topic</option>
                        {getAvailableTopics(subject2, subject1).map(topic => (
                            <option key={topic} value={topic}>{topic}</option>
                        ))}
                    </select>
                )}
            </div>
            <div style={{display: 'flex', gap: '1em', marginBottom: '2em'}}>
                <button
                    onClick={() => {
                        setTimer1(DEBATE_TIMER_DURATION);
                        setTimer2(DEBATE_TIMER_DURATION);
                        setTimer1Running(false);
                        setTimer2Running(false);
                        setActiveTimer(null);
                        if (props.newState) {
                            props.newState({
                                ...props.state,
                                voxSenatusState: {
                                    ...props.state.voxSenatusState,
                                    currentDebate: 1,
                                    timer1: DEBATE_TIMER_DURATION,
                                    timer2: DEBATE_TIMER_DURATION,
                                    timer1Running: false,
                                    timer2Running: false
                                }
                            });
                        }
                    }}
                    style={{background: props.state?.voxSenatusState?.currentDebate === 1 ? '#d1eaff' : '#fff'}}
                >
                    Set Debate 1 Active
                </button>
                <button
                    onClick={() => {
                        setTimer1(DEBATE_TIMER_DURATION);
                        setTimer2(DEBATE_TIMER_DURATION);
                        setTimer1Running(false);
                        setTimer2Running(false);
                        setActiveTimer(null);
                        if (props.newState) {
                            props.newState({
                                ...props.state,
                                voxSenatusState: {
                                    ...props.state.voxSenatusState,
                                    currentDebate: 2,
                                    timer1: DEBATE_TIMER_DURATION,
                                    timer2: DEBATE_TIMER_DURATION,
                                    timer1Running: false,
                                    timer2Running: false
                                }
                            });
                        }
                    }}
                    style={{background: props.state?.voxSenatusState?.currentDebate === 2 ? '#d1eaff' : '#fff'}}
                >
                    Set Debate 2 Active
                </button>
                <button
                    onClick={() => {
                        setTimer1Running(false);
                        setTimer2Running(false);
                        setActiveTimer(null);
                        if (props.newState) {
                            props.newState({
                                ...props.state,
                                voxSenatusState: {
                                    ...props.state.voxSenatusState,
                                    currentDebate: 0,
                                    timer1Running: false,
                                    timer2Running: false
                                }
                            });
                        }
                    }}
                    style={{background: !props.state?.voxSenatusState?.currentDebate ? '#d1eaff' : '#fff'}}
                >
                    No Debate Active
                </button>
            </div>
            {/* Timers for active debate */}
            {props.state?.voxSenatusState?.currentDebate !== 0 && (
                <div style={{marginBottom: '2em'}}>
                    <h3>Debate {props.state.voxSenatusState.currentDebate} Timers</h3>
                    <div style={{display: 'flex', gap: '2em'}}>
                        {/* Timer 1 */}
                        <div>
                            <div>Timer 1</div>
                            <div style={{fontSize: '2em'}}>
                                {timer1 !== null ? `${Math.floor(timer1 / 60)}:${String(timer1 % 60).padStart(2, '0')}` : '3:30'}
                            </div>
                            <button
                                onClick={startTimer1}
                                disabled={timer1Running}
                            >
                                Start Timer 1
                            </button>
                        </div>
                        {/* Timer 2 */}
                        <div>
                            <div>Timer 2</div>
                            <div style={{fontSize: '2em'}}>
                                {timer2 !== null ? `${Math.floor(timer2 / 60)}:${String(timer2 % 60).padStart(2, '0')}` : '3:30'}
                            </div>
                            <button
                                onClick={startTimer2}
                                disabled={timer2Running}
                            >
                                Start Timer 2
                            </button>
                        </div>
                    </div>
                    <button
                        style={{marginTop: '1em'}}
                        onClick={stopBothTimers}
                    >
                        Stop Both Timers
                    </button>
                </div>
            )}
            <br/>
            <button onClick={handleReset}>
                Reset Teams & Topic
            </button>
            <br/>
            <br/>
            <div style={{margin: "2em 0"}}>
                <h2>Timer</h2>
                {timerStart ? (
                    <div>
                        Time left: {Math.floor(remaining / 60)}:{String(remaining % 60).padStart(2, "0")}
                        {remaining === 0 && <span style={{color: "red", marginLeft: "1em"}}>Time's up!</span>}
                    </div>
                ) : (
                    <button onClick={handleStartTimer}>Start 5 min Timer</button>
                )}
            </div>
        </div>
    );
}